import request from "../../config/axios";

// Update user profile information
const updateUserProfile = (userData) => {
  return request.put('/wp-json/custom-auth/v1/profile', userData, {
    withCredentials: true
  });
};

// Get user profile information
const getUserProfile = () => {
  return request.get('/wp-json/custom-auth/v1/profile', {
    withCredentials: true
  });
};

// Get user order history
const getUserOrderHistory = (customer_id,page=1) => {
  return request.get(`/wp-json/custom/v1/order-data?customer_id=${customer_id}&page=${page}`, {
    withCredentials: true
  });
};

export { 
  updateUserProfile, 
  getUserProfile, 
  getUserOrderHistory 
};
